import { createSelector, MemoizedSelector } from '@ngrx/store';
import { uniqBy } from 'lodash';
import {
  DASHBOARD_APP_NAME
} from '@content-platform/web/angular/shared/data-access/application-api/src/lib/constants';
import {
  userPermissionListSelectors,
  applicationSelectors
} from '@content-platform/web/angular/shared/data-access/application-api/src/lib/selectors';
import { CardDetails } from '@content-platform/reusable-ui/card';

/**
 * Selector to return all the application cards.
 * Dashboard is filtered out from the cards to be shown on the dashboard.
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export const getAllApplicationCards: MemoizedSelector<object, CardDetails[]> = createSelector(
  userPermissionListSelectors.getUserApplications,
  applicationSelectors.getAllApplicationItems,
  (userApplications, allApplications) => {
    const displayableUserApps = userApplications.filter(
      app => app.name !== DASHBOARD_APP_NAME && !app.hidden
    );
    const comingSoonApps = allApplications.filter(app => app.comingSoon);

    const displayableApps = uniqBy([...displayableUserApps, ...comingSoonApps], 'id');

    const orderedApps = [
      ...displayableApps.filter(app => !app.comingSoon),
      ...displayableApps.filter(app => app.comingSoon)
    ];

    return orderedApps.map<CardDetails>(
      app =>
        <CardDetails>{
          id: app.name,
          imageSrc: app.imgUrlLrg || app.imgUrl,
          cardContent: app.name,
          avatarImgSrc: app.icon,
          color: app.color,
          external: app.external,
          comingSoon: app.comingSoon
        }
    );
  }
);
